"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMappedPermissions = void 0;
var react_1 = require("react");
var usePermissionsModalContext_1 = require("./usePermissionsModalContext");
function useMappedPermissions(objectType, objectId) {
    var usePermissions = (0, usePermissionsModalContext_1.usePermissionsModalContext)().usePermissions;
    var permissions = usePermissions(objectType, objectId).data;
    return (0, react_1.useMemo)(function () {
        var _a, _b;
        return {
            users: new Map((_a = permissions === null || permissions === void 0 ? void 0 : permissions.users) === null || _a === void 0 ? void 0 : _a.map(function (user) { return [user.user.userid, user]; })),
            teams: new Map((_b = permissions === null || permissions === void 0 ? void 0 : permissions.teams) === null || _b === void 0 ? void 0 : _b.map(function (team) { return [team.team.teamid, team]; })),
        };
    }, [permissions]);
}
exports.useMappedPermissions = useMappedPermissions;
